// Assigned DDDs in ANATEL's numbering plan.
const VALID_DDDS = new Set([
  11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35, 37, 38, 41, 42, 43,
  44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77,
  79, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99,
])

const JUDGED_LENGTHS = [10, 11]

// No Brazilian subscriber number starts with 0 or 1 (landlines 2-5, legacy
// SME/radio 7, mobiles 9). For 10-digit numbers we only reject these impossible
// starts — old-format mobiles and mobiles typed without the leading 9 are
// accepted rather than discarded.
const IMPOSSIBLE_10_DIGIT_SUBSCRIBER_STARTS = new Set(['0', '1'])

export type FakePhoneReason = 'repeated_digits' | 'nonexistent_ddd' | 'invalid_subscriber_prefix'

function isSameDigitRepeated(digits: string): boolean {
  return digits.split('').every((digit) => digit === digits[0])
}

// 11-digit numbers must be a mobile (subscriber starts with 9, ANATEL's nono
// dígito, 2017). 10-digit numbers are accepted unless the subscriber starts with
// an impossible 0/1.
function hasValidSubscriberPrefix(digits: string): boolean {
  const first = digits[2]
  if (digits.length === 11) return first === '9'
  return !IMPOSSIBLE_10_DIGIT_SUBSCRIBER_STARTS.has(first)
}

export function getObviouslyFakePhoneReason(digits: string): FakePhoneReason | null {
  // Only judges length-valid numbers; other lengths are already rejected by the form.
  if (!JUDGED_LENGTHS.includes(digits.length)) return null
  if (isSameDigitRepeated(digits)) return 'repeated_digits'
  if (!VALID_DDDS.has(Number(digits.slice(0, 2)))) return 'nonexistent_ddd'
  if (!hasValidSubscriberPrefix(digits)) return 'invalid_subscriber_prefix'
  return null
}
